import { useCallback, useMemo } from 'react';

import moment from 'moment';

import { FIELDS_NAME } from './BlockCarIssueDate.constants';

export const useBlockCarIssueDatePresenter = ({ carInstance, onPatch, onSetErrors }) => {
  const { [FIELDS_NAME.CAR_ISSUE_DATE]: carIssueDate } = carInstance;

  const value = useMemo(() => {
    if (!carIssueDate) {
      return;
    }

    return moment(carIssueDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
  }, [carIssueDate]);

  const onChangeCarIssueDate = useCallback(
    ({ [FIELDS_NAME.CAR_ISSUE_DATE]: rawCarIssueDate }) => {
      if (typeof rawCarIssueDate !== 'string') {
        return;
      }

      const carIssueDate = moment(rawCarIssueDate, 'DD.MM.YYYY').format('YYYY-MM-DD');

      if (carIssueDate === 'Invalid date') {
        return;
      }

      onPatch({ ...carInstance, [FIELDS_NAME.CAR_ISSUE_DATE]: carIssueDate });
      onSetErrors({ [FIELDS_NAME.CAR_ISSUE_DATE]: '' });
    },
    [onPatch, carInstance, onSetErrors]
  );

  return { onChangeCarIssueDate, value };
};
